import "./assets/main.css";
import "./assets/jquery-ui.min.css";
import $ from "jquery";
window.jQuery = window.$ = $;

import { createApp } from "vue";
import { createPinia } from "pinia";
import DOMPurify from 'dompurify';

import App from "./App.vue";
import router from "./router";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
  faUserSecret,
  faGaugeHigh,
  faHeartPulse,
  faKey,
  faBell,
  faFileLines,
  faExclamation,
  faCheck,
  faGear,
  faPencil,
  faCircleInfo,
  faCaretDown,
  faEllipsis,
  faCloudArrowUp,
  faPaintBrush,
  faRotateLeft,
  faEraser,
  faUsers,
  faEye,
  faTrashCan,
  faShareFromSquare,
  faMagnifyingGlass,
  faPlus,
  faPenFancy,
  faT,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faFont,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faXmark,
  faInfo,
  faEyeSlash,
  faClockRotateLeft,
  faFileInvoice,
  faCheckCircle,
  faChartSimple,
  faCircleExclamation,
  faStamp
} from "@fortawesome/free-solid-svg-icons";

import {
  faFile,
  faCircleCheck,
  faCircleXmark,
  faClone,
} from "@fortawesome/free-regular-svg-icons";

/* add icons to the library */
library.add(
  faUserSecret,
  faGaugeHigh,
  faHeartPulse,
  faKey,
  faBell,
  faFileLines,
  faFile,
  faExclamation,
  faCheck,
  faCircleCheck,
  faGear,
  faPencil,
  faCircleInfo,
  faCaretDown,
  faEllipsis,
  faCloudArrowUp,
  faPaintBrush,
  faRotateLeft,
  faEraser,
  faUsers,
  faEye,
  faTrashCan,
  faShareFromSquare,
  faMagnifyingGlass,
  faCircleXmark,
  faPlus,
  faPenFancy,
  faT,
  faClone,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faFont,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faXmark,
  faExclamation,
  faInfo,
  faEyeSlash,
  faClockRotateLeft,
  faFileInvoice,
  faCheckCircle,
  faChartSimple,
  faCircleExclamation,
  faStamp

);

import baseLayout from "@/components/layout/BaseLayout.vue";
import timeConverter from "./helper/services/timeConverter";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App);
import LayoutAuth from "@/layout/LayoutAuth.vue";

app.component('VueDatePicker', VueDatePicker);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("base-layout", baseLayout);
app.component("layout-auth", LayoutAuth);
app.use(createPinia());
app.use(timeConverter)
app.use(router);
let delayTimeout
app.directive('sanitize', (el,) => {
  clearTimeout(delayTimeout);

  delayTimeout = setTimeout(() => {
    let original = el.value
    const sanitizedInput = DOMPurify.sanitize(el.value.trim());
    if (sanitizedInput != original) {
      el.value = sanitizedInput;
      el.dispatchEvent(new Event('input')); // Memastikan data v-model terupdate
    }
  }, 500);
})

app.mount("#app");
